import type { RotationModel } from "../types/celestialBody";
import { J2000_JD } from "./constants";
import { degToRad, normalizeAngleRad } from "./kepler";

/**
 * Ângulo de rotação sidérea em radianos em torno do eixo do corpo.
 */
export function calculateBodyRotation(
  rotation: RotationModel,
  julianDate: number,
): number {
  const rotationPeriodDays = rotation.siderealRotationPeriodHours / 24;
  if (rotationPeriodDays === 0) return 0;

  const epoch = rotation.epochJulianDate ?? J2000_JD;
  const elapsedDays = julianDate - epoch;
  const turns = elapsedDays / rotationPeriodDays;
  const direction = rotation.rotationDirection === "retrograde" ? -1 : 1;
  const prime = degToRad(rotation.primeMeridianAtEpochDeg ?? 0);

  return normalizeAngleRad(prime + direction * turns * Math.PI * 2);
}
